import { render, staticRenderFns } from "./smartRouting.vue?vue&type=template&id=11f4e5dd&"
import script from "./smartRouting.vue?vue&type=script&lang=js&"
export * from "./smartRouting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports